import { grommet } from 'grommet'
import { Ascending, Descending } from 'grommet-icons'
import { deepMerge } from 'grommet/utils'
import '../assets/fonts/font.css'
import { NextItemIcon, PreviousItemIcon } from '../assets/svgs'
import { palette } from './palette'

const AppTheme = deepMerge(grommet, {
  button: {
    default: {
      background: {
        color: '', // Default button background color
        opacity: 'strong'
      },
      border: {
        color: 'transparent',
        radius: '100%'
      },
      color: 'brand', // Default button text color
      padding: {
        // vertical: '12px',
        // horizontal: '24px',
      }
      // extend: `
      //   font-weight: bold;
      // `
    },
    hover: {
      default: {
        // background: '#DFDAFE'
      },
      primary: {},
      secondary: {
        background: 'primary',
        opacity: 'strong'
      }
    },
    primary: {
      background: {
        color: 'primary' // Use custom primary color
      },
      border: {
        color: 'transparent'
      },
      color: 'background-contrast', // Contrast color for text
      padding: {
        // vertical: '12px',
        // horizontal: '24px',
      }
      // extend: `
      //   font-weight: normal;
      // `
    },
    secondary: {
      background: {
        color: 'transparent', // Secondary button background is transparent
        opacity: 'strong'
      },
      border: {
        color: 'secondary', // Use custom secondary color for border
        width: '1px'
      },
      color: '#000000', // Use custom secondary color for text
      padding: {
        // vertical: '12px',
        // horizontal: '24px',
      }
      // extend: `
      //   font-weight: 500;
      // `
    }
  },
  calendar: {
    medium: {
      daySize: '35px',
      fontSize: '14px',
      lineHeight: 0.5
    }
  },
  checkBox: {
    border: {
      color: palette.brand,
      width: '2px'
    },
    check: {
      extend: (props: { checked: any }) => `
        background-color: ${props.checked ? palette.brand : 'white'};
        color: ${props.checked ? 'white' : palette.brand};
      `,
      thickness: '2px'
    },
    color: (props: { checked: any }) => (props.checked ? 'white' : palette.brand),
    size: '18px'
  },
  dataTable: {
    icons: {
      ascending: Ascending,
      descending: Descending
    }
  },
  dateInput: {
    container: { 'min-height': 'max-content', round: 'medium' }
  },

  drop: {
    elevation: 'small'
  },
  global: {
    colors: {
      appleGreen: palette.appleGreen,

      asparagus: palette.asparagus,

      // Secondary button color
      'background-contrast': palette.white,

      // Background color for contrast (e.g., button text)
      // Add other custom colors as needed
      black: palette.black,

      brand: palette.brand,

      greenKelp: palette.greenKelp,

      juggleGreen: palette.juggleGreen,

      // Your brand color
      primary: palette.primary,
      // Primary button color
      secondary: palette.secondary
    },
    focus: {
      border: {
        color: 'none',
        width: 1
      }
    },
    font: {
      face: {
        'font-family': 'Archivo'
      },
      // prettier-ignore
      family: "Archivo",
      height: '20px',
      size: '14px'
    },
    input: {
      background: 'white',
      focus: {
        background: 'white'
      },
      padding: {
        left: '20px'
      }
    },
    size: {
      medium: '270px',
      small: '220px'
    }
  },
  maskedInput: {
    extend: `
        border-radius: 100px;
      `
  },
  menu: {
    extend: {},
    group: {
      container: {
        pad: { vertical: 'none' }
      },
      separator: {
        pad: {
          horizontal: 'small',
          vertical: 'none'
        }
      }
    }
  },
  pagination: {
    button: {
      active: {
        background: {
          color: '#F6F872'
        }
      },
      hover: {
        background: {
          color: '#dddddd'
        }
      }
    },
    control: {
      extend: {}
    },
    icons: {
      next: NextItemIcon,
      previous: PreviousItemIcon
    }
  },
  select: {
    control: {
      extend: `
        border-radius: 100px;
      `
    }
  },
  tab: {
    active: {
      border: '2px solid black',
      color: 'black'
    },
    border: {
      active: {
        color: 'brand',
        height: '2px',
        style: 'solid'
      },
      color: 'transparent',
      style: 'hidden'
    },
    color: '#666666',
    extend: {
      'font-size': '14px !important',
      margin: '0px',
      'padding-bottom': '8px'
    }
  },
  tabs: {
    gap: 'small'
  }
})

export default AppTheme
export * from './palette'
